// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `td[data-v-9645d286]{text-align:center}`, "",{"version":3,"sources":["webpack://./src/components/ManageBunk/RouteComponents/OpeningCashBalance/styles.scoped.scss"],"names":[],"mappings":"AAAA,oBAAoB,iBAAiB","sourcesContent":["td[data-v-9645d286]{text-align:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
